<template>
<div>
    <Topside />
  <div class="main">
    <div class="box">
      <div class="boxtitle">利用案内</div>
      <div class="box-1 box-scroll">
  
          <!-- テキスト表示(Content3) -->
          <!--<p style="word-wrap: break-word; white-space: pre-wrap;" v-html="contentsData.Content3"></p>-->
          <p style="word-wrap: break-word;"v-html="contentsData.Content3"></p>

      </div>

    </div>
  </div>
</div>

</template>
<script>
import Topside from '@/components/Treeside.vue'

// @ is an alias to /src
import axios from 'axios'
export default {
  //name: 'Riyou',
  name: 'guide',
  components: {
    Topside
  },
  computed: {
    /**
      * コンテンツの取得
      */
    contentsData() {
      return this.$store.getters.content
    }
  },
  created: function() {
    var self = this
    self.init()
  },

  
  data () {
    return {
      //kaisodata: []
      //contentsData: [] //コンテンツデータ
    }
  },
  mounted: function () {
    var self = this
    self.init()
    
  },
  methods: {
    init () {
      this.getAllKaisoData(function(res){})
    },
  }
}
</script>